import { WithPinning } from "../docs/app/app.path.types";


// Shared static hardcoded values

// For the generic user search with "pinning users" feature.
export const withPinningDefault: WithPinning = {
  delayUntilPinHide: 1800, // default value for delay until the pin hides in generic user search with pinning hide in milliseconds, can be overridden by environment variables or other config sources
};
